import { CurrentMobile } from '@mri/types';
import { SensorConfig } from '../types/sensor-config';

export function getSensorsOfCurrent(current: CurrentMobile): Array<SensorConfig> {

    const { mobile, hardware } = current;

    const sensorKeys = [
        ...new Set([...(hardware?.config?.sensors || []).map(s => s.key)]),
        ...new Set([...(mobile?.config?.sensors || []).map(s => s.key)])
    ];

    return sensorKeys
        .map(key => {
            const indexCurrent = (hardware?.config?.sensors || []).findIndex(s => s.key === key);
            const indexMobile = (mobile?.config?.sensors || []).findIndex(s => s.key === key);

            const originalSensor = hardware?.config?.sensors?.[indexCurrent] || {};
            const mobileSensor = mobile?.config?.sensors?.[indexMobile] || {};

            return  { ...originalSensor, ...mobileSensor } as SensorConfig;
        });
}
